import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const MicrosoftFabric = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="MicrosoftFabric"
    height={height}
    width={width}
    title="Microsoft Fabric logo"
    titleId="fabric-logo-title"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="m5.64 31.6-.586 2.144c-.218.685-.524 1.693-.689 2.59a5.629 5.629 0 0 0 4.638 7.588c.792.114 1.688.108 2.692-.04l4.613-.636a2.924 2.924 0 0 0 2.421-2.127l3.175-11.662L5.64 31.599Z"
      fillRule="evenodd"
      fill="url(#a)"
    />
    <path
      d="M10.14 32.152c-4.863.753-5.861 4.423-5.861 4.423l4.656-17.11 24.333-3.292-3.318 12.052a1.706 1.706 0 0 1-1.388 1.244l-.136.022-18.423 2.684.137-.023Z"
      fill="url(#b)"
    />
    <path
      d="M10.14 32.152c-4.863.753-5.861 4.423-5.861 4.423l4.656-17.11 24.333-3.292-3.318 12.052a1.706 1.706 0 0 1-1.388 1.244l-.136.022-18.423 2.684.137-.023Z"
      fillOpacity=".8"
      fill="url(#c)"
    />
    <path
      d="m12.899 21.235 26.938-3.98a1.597 1.597 0 0 0 1.323-1.17l2.78-10.06a1.595 1.595 0 0 0-1.74-2.012L16.498 7.81a7.185 7.185 0 0 0-5.777 5.193L7.013 26.438c.744-2.717 1.202-4.355 5.886-5.203Z"
      fill="url(#d)"
    />
    <path
      d="m12.899 21.235 26.938-3.98a1.597 1.597 0 0 0 1.323-1.17l2.78-10.06a1.595 1.595 0 0 0-1.74-2.012L16.498 7.81a7.185 7.185 0 0 0-5.777 5.193L7.013 26.438c.744-2.717 1.202-4.355 5.886-5.203Z"
      fill="url(#e)"
    />
    <path
      d="m12.899 21.235 26.938-3.98a1.597 1.597 0 0 0 1.323-1.17l2.78-10.06a1.595 1.595 0 0 0-1.74-2.012L16.498 7.81a7.185 7.185 0 0 0-5.777 5.193L7.013 26.438c.744-2.717 1.202-4.355 5.886-5.203Z"
      fillOpacity=".4"
      fill="url(#f)"
    />
    <path
      d="M12.899 21.236c-3.901.706-4.87 1.962-5.514 3.932L4.279 36.577s.992-3.633 5.796-4.41l18.352-2.673.136-.022a1.707 1.707 0 0 0 1.388-1.244l2.73-9.915-19.782 2.923Z"
      fill="url(#g)"
    />
    <path
      d="M12.899 21.236c-3.901.706-4.87 1.962-5.514 3.932L4.279 36.577s.992-3.633 5.796-4.41l18.352-2.673.136-.022a1.707 1.707 0 0 0 1.388-1.244l2.73-9.915-19.782 2.923Z"
      fillOpacity=".2"
      fill="url(#h)"
    />
    <path
      clipRule="evenodd"
      d="M10.075 32.167c-4.06.657-5.392 3.345-5.71 4.164a5.629 5.629 0 0 0 4.638 7.59c.792.114 1.688.108 2.692-.039l4.613-.637a2.924 2.924 0 0 0 2.421-2.127l2.894-10.633-11.547 1.683-.001-.001Z"
      fillRule="evenodd"
      fill="url(#i)"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="29.457"
        y1="44.001"
        x2="12.953"
        x1="12.953"
        id="a"
      >
        <stop stopColor="#2AAC94" offset=".056" />
        <stop stopColor="#239C87" offset=".155" />
        <stop stopColor="#177E71" offset=".372" />
        <stop stopColor="#0E6961" offset=".588" />
        <stop stopColor="#095D57" offset=".799" />
        <stop stopColor="#085954" offset="1" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="18.173"
        y1="33.448"
        x2="17.286"
        x1="31.331"
        id="b"
      >
        <stop stopColor="#ABE88E" offset=".042" />
        <stop stopColor="#2AAA92" offset=".549" />
        <stop stopColor="#117865" offset=".906" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="28.148"
        y1="32.706"
        x2="10.183"
        x1="-3.182"
        id="c"
      >
        <stop stopColor="#6AD6F9" />
        <stop stopOpacity="0" stopColor="#6AD6F9" offset="1" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="15.219"
        y1="15.219"
        x2="42.589"
        x1="7.013"
        id="d"
      >
        <stop stopColor="#25FFD4" offset=".043" />
        <stop stopColor="#55DDB9" offset=".874" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="25.128"
        y1="10.247"
        x2="39.06"
        x1="7.013"
        id="e"
      >
        <stop stopColor="#6AD6F9" />
        <stop stopColor="#60E9D0" offset=".23" />
        <stop stopColor="#6DE9BB" offset=".651" />
        <stop stopColor="#ABE88E" offset=".994" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="16.885"
        y1="13.031"
        x2="27.404"
        x1="9.978"
        id="f"
      >
        <stop stopOpacity="0" stopColor="#fff" />
        <stop stopColor="#fff" offset=".459" />
        <stop stopOpacity="0" stopColor="#fff" offset="1" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="15.74"
        y1="27.96"
        x2="16.168"
        x1="15.756"
        id="g"
      >
        <stop stopOpacity="0" stopColor="#063D3B" offset=".205" />
        <stop stopOpacity=".237" stopColor="#063D3B" offset=".586" />
        <stop stopOpacity=".75" stopColor="#063D3B" offset=".872" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="29.545"
        y1="26.744"
        x2="17.701"
        x1="2.81"
        id="h"
      >
        <stop stopOpacity="0" stopColor="#fff" />
        <stop stopColor="#fff" offset=".459" />
        <stop stopOpacity="0" stopColor="#fff" offset="1" />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        y2="25.764"
        y1="39.97"
        x2="10.662"
        x1="13.567"
        id="i"
      >
        <stop stopOpacity="0" stopColor="#063D3B" offset=".064" />
        <stop stopOpacity=".135" stopColor="#063D3B" offset=".17" />
        <stop stopOpacity=".599" stopColor="#063D3B" offset=".562" />
        <stop stopOpacity=".9" stopColor="#063D3B" offset=".85" />
        <stop stopColor="#063D3B" offset="1" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
